(function () {
  'use strict';

  function normalizePath(path) {
    return (path || '').replace(/\/+$/, '') || '/';
  }

  function isSamePage(a, b) {
    return normalizePath(a) === normalizePath(b);
  }

  function resolvePath(href) {
    try {
      return normalizePath(new URL(href, window.location.origin).pathname);
    } catch (error) {
      return normalizePath(href);
    }
  }

  function parseSection(section, pageUrl, category) {
    var id = section.id || '';
    var title = section.querySelector('.center-section__title')?.textContent.trim() || '';
    var questions = [...section.querySelectorAll('.center-topic h3, .center-topic__title')].map(function (q) {
  return q.textContent.trim();
});

    return {
      title: title,
      category: category || '',
      url: pageUrl + (id ? '#' + id : ''),
      pageUrl: pageUrl,
      sectionId: id,
      questions: questions,
      text: section.textContent.replace(/\s+/g, ' ').trim().toLowerCase(),
    };
  }

  function parseCategoryLinks(scope, pageUrl, fallbackCategory) {
    var entries = [];

    scope.querySelectorAll('.center-directory__card').forEach(function (card) {
      var cardCategory = card.querySelector('.center-directory__card-title')?.textContent.trim() || fallbackCategory || '';
      var description = card.querySelector('.center-directory__card-description')?.textContent.trim() || '';

      card.querySelectorAll('.center-directory__link').forEach(function (link) {
        var label = link.querySelector('span')?.textContent.trim();
        var href = link.getAttribute('href');
        if (!label || !href || href === '#') return;

        entries.push({
          title: label,
          category: cardCategory,
          url: href,
          pageUrl: resolvePath(href),
          sectionId: '',
          questions: [],
          text: (label + ' ' + cardCategory + ' ' + description).replace(/\s+/g, ' ').trim().toLowerCase(),
        });
      });
    });

    scope.querySelectorAll('.center-directory__action-card').forEach(function (card) {
      var title = card.querySelector('.center-directory__action-title')?.textContent.trim();
      var description = card.querySelector('.center-directory__action-description')?.textContent.trim() || '';
      var href = card.getAttribute('href');
      if (!title || !href || href === '#') return;

      entries.push({
        title: title,
        category: 'Quick actions',
        url: href,
        pageUrl: resolvePath(href),
        sectionId: '',
        questions: [],
        text: (title + ' ' + description).replace(/\s+/g, ' ').trim().toLowerCase(),
      });
    });

    return entries;
  }

  function collectEntries(scope, pageUrl, category) {
    var entries = [];

    scope
      .querySelectorAll(
        '.center-page .center-section, .center-article .center-section, .center-section'
      )
      .forEach(function (section) {
        entries.push(parseSection(section, pageUrl, category));
      });

    parseCategoryLinks(scope, pageUrl, category).forEach(function (entry) {
      entries.push(entry);
    });

    return entries;
  }

  function scoreEntry(entry, query) {
    var q = query.toLowerCase();
    var score = 0;

    if (entry.title.toLowerCase().includes(q)) score += 100;
    if (entry.category.toLowerCase().includes(q)) score += 60;
    entry.questions.forEach(function (question) {
      if (question.toLowerCase().includes(q)) score += 80;
    });
    if (entry.text.includes(q)) score += 20;

    return score;
  }

  function dedupePages(pages) {
    var seen = {};

    return pages.filter(function (page) {
      var key = normalizePath(page.url);
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function HelpCenterSearch(root) {
    this.root = root;
    this.input = root.querySelector('.center-search__input');
    this.resultsEl = root.querySelector('.center-search__results');
    this.statusEl = root.querySelector('.center-search__status');
    this.form = root.querySelector('.center-search__form');
    this.configEl = document.getElementById('center-search-data');
    this.pages = [];
    this.index = null;
    this.buildPromise = null;
    this.activeIndex = -1;
    this.debounceTimer = null;
    this.onLayoutChange = this.positionResults.bind(this);

    if (!this.input || !this.resultsEl) return;

    // Keep results out of the hero/nav stacking context so the dropdown always sits above the Center nav.
    if (this.resultsEl.parentNode !== document.body) {
      document.body.appendChild(this.resultsEl);
    }

    if (this.configEl) {
      try {
        this.pages = dedupePages(JSON.parse(this.configEl.textContent));
      } catch (error) {
        this.pages = [];
      }
    }

    this.bindEvents();
  }

  HelpCenterSearch.prototype.bindEvents = function () {
    var self = this;

    this.input.addEventListener('input', function () {
      clearTimeout(self.debounceTimer);
      self.debounceTimer = setTimeout(function () {
        self.handleInput();
      }, 200);
    });

    this.input.addEventListener('focus', function () {
      if (self.input.value.trim().length >= 2) {
        self.handleInput();
      }
    });

    this.input.addEventListener('keydown', function (event) {
      self.handleKeydown(event);
    });

    if (this.form) {
      this.form.addEventListener('submit', function (event) {
        event.preventDefault();
        self.submitFirstResult();
      });
    }

    document.addEventListener('click', function (event) {
      if (!self.root.contains(event.target) && !self.resultsEl.contains(event.target)) {
        self.hideResults();
      }
    });

    window.addEventListener('resize', this.onLayoutChange);
    window.addEventListener('scroll', this.onLayoutChange, true);
  };

  HelpCenterSearch.prototype.positionResults = function () {
    if (!this.form || this.resultsEl.hidden) return;

    var rect = this.form.getBoundingClientRect();
    this.resultsEl.style.top = rect.bottom + 6 + 'px';
    this.resultsEl.style.left = rect.left + 'px';
    this.resultsEl.style.width = rect.width + 'px';
  };

  HelpCenterSearch.prototype.setStatus = function (message) {
    if (!message) {
      if (this.statusEl) this.statusEl.textContent = '';
      return;
    }

    this.resultsEl.hidden = false;
    document.documentElement.classList.add('center-search-open');
    this.resultsEl.innerHTML = '<div class="center-search__empty">' + this.escapeHtml(message) + '</div>';
    this.positionResults();
  };

  HelpCenterSearch.prototype.buildIndex = function () {
    var self = this;

    if (this.index) {
      return Promise.resolve(this.index);
    }

    if (this.buildPromise) {
      return this.buildPromise;
    }

    this.setStatus('Searching help articles…');

    this.buildPromise = Promise.resolve().then(function () {
      var entries = [];
      var currentPath = normalizePath(window.location.pathname);
      var currentCategory = self.getCategoryForUrl(currentPath);

      collectEntries(document, currentPath, currentCategory).forEach(function (entry) {
        entries.push(entry);
      });

      var otherPages = self.pages.filter(function (page) {
        return !isSamePage(page.url, currentPath);
      });

      return Promise.all(
        otherPages.map(function (page) {
          return fetch(page.url, { credentials: 'same-origin' })
            .then(function (response) {
              return response.text();
            })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              collectEntries(doc, normalizePath(page.url), page.category).forEach(function (entry) {
                entries.push(entry);
              });
            })
            .catch(function () {
              return null;
            });
        })
      ).then(function () {
        self.index = entries;
        self.setStatus('');
        return self.index;
      });
    });

    return this.buildPromise;
  };

  HelpCenterSearch.prototype.getCategoryForUrl = function (url) {
    var match = this.pages.find(function (page) {
      return isSamePage(page.url, url);
    });
    return match ? match.category : '';
  };

  HelpCenterSearch.prototype.handleInput = function () {
    var self = this;
    var query = this.input.value.trim();

    if (query.length < 2) {
      this.hideResults();
      this.setStatus('');
      return;
    }

    this.buildIndex().then(function () {
      var results = self.search(query);
      self.renderResults(results, query);
    });
  };

  HelpCenterSearch.prototype.search = function (query) {
    if (!this.index) return [];

    return this.index
      .map(function (entry) {
        return {
          entry: entry,
          score: scoreEntry(entry, query),
        };
      })
      .filter(function (item) {
        return item.score > 0;
      })
      .sort(function (a, b) {
        return b.score - a.score;
      })
      .slice(0, 8)
      .map(function (item) {
        return item.entry;
      });
  };

  HelpCenterSearch.prototype.renderResults = function (results, query) {
    var self = this;

    this.resultsEl.innerHTML = '';
    this.activeIndex = -1;

    if (!results.length) {
      this.resultsEl.hidden = false;
      document.documentElement.classList.add('center-search-open');
      this.resultsEl.innerHTML =
        '<div class="center-search__empty">No Brilinton Center articles found for “' +
        this.escapeHtml(query) +
        '”</div>';
      this.positionResults();
      return;
    }

    results.forEach(function (result, index) {
      var item = document.createElement('button');
      item.type = 'button';
      item.className = 'center-search__result';
      item.setAttribute('role', 'option');
      item.dataset.index = String(index);

      var matchedQuestion = result.questions.find(function (question) {
        return question.toLowerCase().includes(query.toLowerCase());
      });

      item.innerHTML =
        '<span class="center-search__result-title">' +
        self.escapeHtml(result.title) +
        '</span>' +
        '<span class="center-search__result-meta">' +
        self.escapeHtml(result.category) +
        (matchedQuestion ? ' · ' + self.escapeHtml(matchedQuestion) : '') +
        '</span>';

      item.addEventListener('click', function () {
        self.navigateToResult(result);
      });

      self.resultsEl.appendChild(item);
    });

    this.resultsEl.hidden = false;
    document.documentElement.classList.add('center-search-open');
    this.input.setAttribute('aria-expanded', 'true');
    this.positionResults();
  };

  HelpCenterSearch.prototype.hideResults = function () {
    this.resultsEl.hidden = true;
    document.documentElement.classList.remove('center-search-open');
    this.resultsEl.innerHTML = '';
    this.activeIndex = -1;
    this.input.setAttribute('aria-expanded', 'false');
    this.resultsEl.style.top = '';
    this.resultsEl.style.left = '';
    this.resultsEl.style.width = '';
  };

  HelpCenterSearch.prototype.navigateToResult = function (result) {
    this.hideResults();
    this.input.blur();

    if (!result.sectionId || !isSamePage(result.pageUrl, window.location.pathname)) {
      window.location.href = result.url;
      return;
    }

    if (isSamePage(result.pageUrl, window.location.pathname)) {
      var link = document.querySelector('.center-scroll-link[href="#' + result.sectionId + '"]');
      if (link) {
        link.click();
        return;
      }

      if (result.sectionId) {
        window.location.hash = result.sectionId;
      }
    }
  };

  HelpCenterSearch.prototype.submitFirstResult = function () {
    var self = this;
    var query = this.input.value.trim();
    if (query.length < 2) return;

    this.buildIndex().then(function () {
      var results = self.search(query);
      if (results.length) {
        self.navigateToResult(results[0]);
      } else {
        self.renderResults([], query);
      }
    });
  };

  HelpCenterSearch.prototype.handleKeydown = function (event) {
    var items = [...this.resultsEl.querySelectorAll('.center-search__result')];
    if (!items.length || this.resultsEl.hidden) return;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.activeIndex = Math.min(this.activeIndex + 1, items.length - 1);
      this.highlightActive(items);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.activeIndex = Math.max(this.activeIndex - 1, 0);
      this.highlightActive(items);
    } else if (event.key === 'Enter' && this.activeIndex >= 0) {
      event.preventDefault();
      items[this.activeIndex].click();
    } else if (event.key === 'Escape') {
      this.hideResults();
    }
  };

  HelpCenterSearch.prototype.highlightActive = function (items) {
    items.forEach(function (item, index) {
      item.classList.toggle('is-active', index === this.activeIndex);
    }, this);
    if (this.activeIndex >= 0) {
      items[this.activeIndex].scrollIntoView({ block: 'nearest' });
    }
  };

  HelpCenterSearch.prototype.escapeHtml = function (value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-center-search]').forEach(function (root) {
      new HelpCenterSearch(root);
    });
  });
})();
